import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaPaperPlane } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import './contactus.css';
import { db } from '../FirebaseComp/firebase'; // adjust path if needed
import { collection, addDoc, Timestamp } from 'firebase/firestore';


function ContactUs() {
 

  const contactMethods = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Our Locations",
      info: "No: 932, Maradana Road,Colombo 08, Sri Lanka\nNo: 23, Uswatta Circular Road, Moratuwa, Sri Lanka",
      link: "",
      animation: { y: [20, 0], opacity: [0, 1] }
      
    },
    {
      icon: <FaPhone />,
      title: "Call Us",
      info: "+94 11 7 700906\n+94 11 7 700906",
      link: "",
      animation: { y: [30, 0], opacity: [0, 1] }
    },
    {
      icon: <FaEnvelope />,
      title: "Email Us",
      info: "ceccmoratuwa@gmail.com\nceccmaradana@gmail.com",
      link: "",
      animation: { y: [40, 0], opacity: [0, 1] }
    },
    {
      icon: <FaClock />,
      title: "Working Hours",
      info: "Monday-Wednesday: 8:30 AM - 5:00 PM\nFriday-Saturday: 8:30 AM - 5:00 PM\nthursday: Closed | Sunday: Closed",
      animation: { y: [50, 0], opacity: [0, 1] }
    }
  ];

  const departments = [
    {
      id: 'general',
      name: 'General Inquiries',
      email: 'info@communityeyecare.lk',
      description: 'For general questions about our services and programs'
    },
    {
      id: 'education',
      name: 'Education Department',
      email: 'education@communityeyecare.lk',
      description: 'Questions about our optometry courses and training'
    },
    {
      id: 'clinical',
      name: 'Clinical Services',
      email: 'clinics@communityeyecare.lk',
      description: 'Appointments and clinical service inquiries'
    },
    {
      id: 'research',
      name: 'Research Division',
      email: 'research@communityeyecare.lk',
      description: 'Collaboration and research opportunities'
    }
  ];







  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
const [isSubmitted, setIsSubmitted] = useState(false);
const [activeTab, setActiveTab] = useState(departments[0]?.id || '');

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({ ...prev, [name]: value }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await addDoc(collection(db, 'contactus'), {
      ...formData,
      department: activeTab,
      timestamp: Timestamp.now(),
    });

    setIsSubmitted(true);
    setFormData({ name: '', email: '', message: '' });

    alert("Message sent successfully!");
  } catch (error) {
    console.error("Error adding document: ", error);
    alert("Something went wrong. Please try again.");
  }
};



  return (
    <div className="contact-page">
      {/* Animated Header */}
      <motion.div 
        className="contact-header"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1>Contact Us</h1>
        <p>We're here to answer your questions and provide the eye care services you need</p>
      </motion.div>

      {/* Main Contact Container */}
      <div className="contact-container">
        {/* Contact Information Section */}
        <motion.div 
          className="contact-info"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>Contact Information</h2>
          <p>Reach out through any of these channels</p>

          <div className="contact-methods">
            {contactMethods.map((method, index) => (
              <motion.div
                key={index}
                className="contact-card"
                initial={{ y: method.animation.y[0], opacity: method.animation.opacity[0] }}
                animate={{ y: method.animation.y[1], opacity: method.animation.opacity[1] }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="contact-icon">{method.icon}</div>
                <h3>{method.title}</h3>
                <p>{method.info.split('\n').map((line, i) => (
                  <React.Fragment key={i}>{line}<br /></React.Fragment>
                ))}</p>
                {method.link && (
                  <a href={method.link} className="contact-link">
                    {method.title.includes('Email') ? 'Send Email' : method.title.includes('Call') ? 'Call Now' : 'View on Map'}
                  </a>
                )}
              </motion.div>
            ))}
          </div>

          {/* Map Embed */}
          <motion.div 
            className="map-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <iframe
              title="Community Eye Care Location"
              src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15842.668404452888!2d79.86328269554937!3d6.930334780325096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sNo%3A%2023%2C%20Uswatta%20Circular%20Road%2C%20Moratuwa!5e0!3m2!1sen!2slk!4v1766981527337!5m2!1sen!2slk"               style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>

        </motion.div>

        {/* Contact Form Section */}
        <motion.div 
          className="contact-form-container"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <div className="form-tabs">
            {departments.map(dept => (
              <button
                key={dept.id}
                className={`tab-btn ${activeTab === dept.id ? 'active' : ''}`}
                onClick={() => setActiveTab(dept.id)}
              >
                {dept.name}
              </button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="form-content"
            >
              <h3>{departments.find(d => d.id === activeTab)?.name}</h3>
              <p>{departments.find(d => d.id === activeTab)?.description}</p>
              
              {isSubmitted ? (
                <motion.div
                  className="success-message"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                >
                  <h3>Thank You!</h3>
                  <p>Your message has been sent successfully. We'll get back to you soon.</p>
                </motion.div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Your Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Your Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <motion.button
                    type="submit"
                    className="submit-btn"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <FaPaperPlane /> Send Message
                  </motion.button>
                </form>
              )}
            </motion.div>
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Emergency Contact Banner */}
      <motion.div 
        className="emergency-banner"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <div className="emergency-content">
          <h3>Emergency Eye Care Services</h3>
          <p>For urgent eye care needs outside regular hours</p>
          <a href="tel:+94117700906" className="emergency-btn">
            <FaPhone /> Call Emergency Hotline: +94 117 700 906
          </a>
        </div>
      </motion.div>
    </div>
  );
}

export default ContactUs;